const LeadGuarantee = ({
    hasLeadGuarantee = null,
    // deprecated
    isEligible = false,
    maxFreeRenewalCount = 0,
    remainingFreeRenewalCount = 0,
} = {}) => ({
    // TODO: remove null check after we fully release feature
    hasLeadGuarantee: hasLeadGuarantee !== null ? Boolean(hasLeadGuarantee) : hasLeadGuarantee,
    isEligible: Boolean(isEligible),
    maxFreeRenewalCount: Number(maxFreeRenewalCount),
    remainingFreeRenewalCount: Number(remainingFreeRenewalCount),
});

export default LeadGuarantee;
